/* eslint-disable no-unused-vars */
import React from "react";

    const MenuItem= [
        {
        title: 'Home',
        icon:'',
        to: '/'
        },
        {
          title: 'Update Form',
          icon:'',
          to: '/form'
        },
        {
          title: 'Self Serve',
          icon:'',
          to: '/selfserve'
         },

         /*{
          title: 'Guarantee Application',
          icon:'',
          to: '/guarantee'
        },*/
         {
          title: 'Privacy Policy',
          icon:'',
          to: '/privacypolicy'
        },
        /*{
          title: 'Rate Our Services',
          icon:'',
          to: '/rateus'
        },*/
      ]

export default MenuItem;